<template>
    <div class="content-container-white">
        <ModuleHeader title="Rechnung bearbeiten (Rechnungsverlauf wird gespeichert)">
        </ModuleHeader>

        <div class="loading" v-if="!invoice && !error">

        </div>

        <div v-if="error" class="error">
            <div class="mb-4">{{ error }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="saveError" class="error">
            <div class="mb-4">{{ saveError }}</div>
            <button type="button" class="btn btn-primary" @click="$router.go(-1)">Zurück</button>
        </div>

        <div v-if="customers && projects && !saveError && !error">
            <form @submit.prevent="updateInvoice" class="center-form default-form">
                <div class="form-group">
                    <label for="invoiceNumber">Rechnungsnummer</label>
                    <input type="text" class="form-control" id="invoiceNumber" aria-describedby="invoiceNumberHelp"
                           v-model="invoice.number"
                           autocomplete="off"
                    >
                </div>

                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputCustomer">Kunde</label>

                        <select id="inputCustomer" class="form-control" v-model="invoice.customerId">
                            <option v-for="customer in customers" v-bind:key="customer.id" v-bind:value="customer.id">{{customer.name}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputState">Projekt</label>

                        <select id="inputState" class="form-control" v-model="invoice.projectId">
                            <option v-for="project in projects.filter(x => x.customerId === invoice.customerId)" v-bind:key="project.id" v-bind:value="project.id">{{project.name}}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group">
                    <label for="invoiceAmount">Betrag</label>
                    <input type="text" class="form-control" id="invoiceAmount" aria-describedby="invoiceAmountHelp"
                           v-model="invoice.amount"
                           autocomplete="off"
                    >
                </div>

                <div class="form-group">
                    <label for="invoiceState">Status</label>
                    <input type="text" class="form-control" id="invoiceState" aria-describedby="invoiceStateHelp"
                           v-model="invoice.state"
                           autocomplete="off"
                    >
                </div>

                <div class="buttons d-flex justify-content-between">
                    <div><button type="submit" class="btn btn-success">Updaten</button></div>
                    <button type="button" class="btn btn-primary" @click="$router.go(-1)">Abbrechen</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import ModuleHeader from "components/util/ModuleHeader";
    import firestore from "firedb/init";


    export default {
        name: "InvoiceEdit",

        components: {ModuleHeader},
        data: function() {
            return {
                invoice: {
                    customerId: null,
                    projectId: null
                },
                error: null,
                saveError: null,
                projects: null,
                customers: null
            }
        },

        created() {

            if (!this.$route.params.id) {
                this.error = "Rechnung wurde nicht gefunden";
                return;
            }

            //TODO change to Promise.all
            firestore.collection('customer').get()
                .then(snapshot => {

                    if (snapshot.size === 0) {
                        return Promise.reject('Keine Kunden gefunden');
                    }

                    this.customers = [];

                    snapshot.forEach(doc => {
                        let customer = doc.data();
                        customer.id = doc.id;

                        this.customers.push(customer);
                    });
                })
                .then(() => {

                    return firestore.collection('project').get()
                        .then(snapshot => {

                            if (snapshot.size === 0) {
                                return Promise.reject('Keine Projekte gefunden');
                            }

                            this.projects = [];

                            snapshot.forEach(doc => {
                                let project = doc.data();
                                project.id = doc.id;

                                this.projects.push(project);
                            });
                        });
                }).then(() => {
                    const ref = firestore.collection('invoice').doc(this.$route.params.id);

                    ref.get().then(doc => {

                        this.invoice = doc.data();
                        this.invoice.id = doc.id;
                    })
                        .catch(e => {
                            console.log(e);
                            this.error = "Rechnung konte nicht geladen werden";
                        });
                })
                .catch((e) => {
                    console.error(e);
                    this.error = 'Für die Erstelleung einer Rechnung notwendige Daten konnten nicht geladen werden.'
                });
        },
        methods: {

            sendToFirebase() {

                const customer = this.customers.filter(x => x.id === this.invoice.customerId)[0];
                const projectName = this.projects.filter(x => x.id === this.invoice.projectId)[0].name;
                const history = this.invoice.history.slice(0); //clone

                const invoice = {
                    number: this.invoice.number,
                    customerId: this.invoice.customerId,
                    projectId: this.invoice.projectId,
                    amount: this.invoice.amount,
                    projectName:  projectName,
                    state: this.invoice.state,
                    version: ++this.invoice.version,
                    customerName: customer.name,
                    customerStreet: customer.street,
                    customerCity: customer.city,
                    customerZip: customer.zip,
                    customerVatId: customer.vatId,

                    issuingCompany: Object.assign({}, this.invoice.issuingCompany)
                };

                history.push(Object.assign({}, invoice));

                invoice.history = history;

                return firestore.collection('invoice').doc(this.invoice.id).update(invoice);
            },
            updateInvoice() {

                //TODO better validation!!!
                if (this.invoice.number && this.invoice.number.trim() !== '' && this.invoice.customerId && this.invoice.projectId && this.invoice.amount) {
                    this.sendToFirebase().then(result => {

                        this.$router.replace('/app/invoice');
                    }).catch(e => {
                        console.error(e);
                        this.saveError = "Rechnung konnte nicht erstellt werden."
                    });
                }
            },
        }
    }
</script>

<style scoped lang="scss">

    .buttons {
        margin-top: 2rem;
    }
</style>